import React from 'react';
import PropTypes from 'prop-types';
import CheckBox from '../CheckBox/CheckBox';
import styles from '../../pages/ReviewOrder/ReviewOrder.module.css';

const SelectionItem = (props) => {
    const {
      main,
      asset,
      label,
      header,
      isSelected,
      onSelect,
      checkIconSrc,
      dataPart,
      hideLabel,
    } = props;
    const classNames = [ styles.selectionContainer, main ? styles.mainContainer : null ].join(' ');

    return (
      <div className={classNames} data-part={dataPart}>
        <div className={styles.itemDetailsContainer}>
          <img alt="" src={asset} />
          <div>
            {!hideLabel && label ? <p>{label}</p> : null}
            <h4>{header}</h4>
          </div>
        </div>
        {!main ? (
          <CheckBox
            onClick={onSelect}
            isChecked={isSelected}
            checkIconSrc={checkIconSrc}
            ariaLabel={header}
          />
        ) : null}
      </div>
    );
};

SelectionItem.propTypes = {
    main: PropTypes.bool,
    asset: PropTypes.oneOfType([
      PropTypes.string.isRequired,
      PropTypes.shape().isRequired
    ]).isRequired,
    label: PropTypes.string.isRequired,
    header: PropTypes.string.isRequired,
    isSelected: PropTypes.bool,
    onSelect: PropTypes.func,
    checkIconSrc: PropTypes.oneOfType([PropTypes.string, PropTypes.shape({})]),
    dataPart: PropTypes.string,
    hideLabel: PropTypes.bool,
}

SelectionItem.defaultProps = {
    isSelected: false,
    onSelect: null,
    main: false,
    checkIconSrc: undefined,
    dataPart: undefined,
    hideLabel: false,
}

export default SelectionItem;
